var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.385-157.617 117.617-388.385q-8.616-8.778-13.116-19.696-4.5-10.919-4.5-22.119 0-11.969 4.5-22.5t13.116-19.531l240.768-240.768-116.307-115.154 32.614-32.23 387.575 388.565q9.436 8.972 13.699 19.525 4.263 10.552 4.263 22.545 0 11.224-4.263 22.11-4.263 10.887-13.737 19.638L432.231-157.617q-9 8.616-19.531 13.116-10.531 4.5-22.5 4.5-11.2 0-22.119-4.5-10.918-4.5-19.696-13.116Zm41.846-523.537L147.924-438.462q-2.308 2.308-3.078 4.616-.769 2.307-.769 4.615h492.692q0-2.308-.769-4.615-.77-2.308-3.078-4.616L390.231-681.154Zm397.501 541.153q-29.883 0-50.538-21.054-20.656-21.053-20.656-51.254 0-23.972 8.846-45.409 8.846-21.436 24.077-39.513l38.615-49.307 39.384 49.307q14.616 18.077 23.769 39.513 9.154 21.437 9.154 45.409 0 30.586-21.192 51.447-21.192 20.861-51.459 20.861Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.4a44068e5b767532a9159befd41ba803.svg";
export { ForwardRef as ReactComponent };